/**
 * Goedgekeurde extra interne links. Wordt alleen weergegeven wanneer een
 * beheerder linkvoorstellen heeft goedgekeurd; bestaande inhoud blijft gelijk.
 */
export type ExtraLink = { targetPath: string; anchor: string };

export function ExtraInternalLinks({ links }: { links: ExtraLink[] }) {
  if (!links || links.length === 0) return null;

  return (
    <section className="mx-auto max-w-5xl px-4 pb-10">
      <h2 className="font-display text-lg font-bold">Populaire taxiritten</h2>
      <ul className="mt-3 flex flex-wrap gap-2">
        {links.map((link) => (
          <li key={link.targetPath}>
            <a
              href={link.targetPath}
              className="inline-flex rounded-full border px-3 py-1 text-sm text-foreground transition-colors hover:bg-accent"
            >
              {link.anchor}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
